import { render, staticRenderFns } from "./NoticeBox.vue?vue&type=template&id=070ed30a&scoped=true"
import script from "./NoticeBox.vue?vue&type=script&lang=js"
export * from "./NoticeBox.vue?vue&type=script&lang=js"
import style0 from "./NoticeBox.vue?vue&type=style&index=0&id=070ed30a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070ed30a",
  null
  
)

export default component.exports